import { ToastMessageContext } from "lib/contexts/message_context";
import ReportsServices from "lib/services/api/reports/reports";
import { getOrganisationId } from "lib/utils/common_utils";
import React, { useContext, useEffect, useState } from "react";

const useGetFilterOptions = () => {
  const [filterOptions, setFilterOptions] = useState({});
  const message = useContext(ToastMessageContext);

  const getDropdownOptions = async () => {
    try {
      const organisation_id = getOrganisationId();
      const response = await ReportsServices.getCategories({ organisation_id });

      const transformedCategoryOptions =
        response?.data?.map((category) => {
          return { id: category?.id, value: category?.name };
        }) || [];

      setFilterOptions({
        categories: transformedCategoryOptions,
      });
    } catch (err) {
      message.showToastMessage({
        message: "Something went wrong while fetching options. Try again!",
        variant: "error",
      });
    }
  };

  useEffect(() => {
    getDropdownOptions();
  }, []);

  return filterOptions;
};

export default useGetFilterOptions;
